














































































import Vue from 'vue';
import { genDownloadImageUrlByImage, sizes } from '@/modules/image';

import {
  publicBuyer,
  PublicBuyer,
  publicBuyerCompany,
  PublicBuyerCompany,
  publicExhibitor,
  PublicExhibitor,
  PublicExhibitorCompany,
  publicExhibitorCompany,
  publicBrand,
  // PublicBrand,
  calender,
  firebase,
} from 'mostra';

import contact, { Contact } from '@/modules/contact/contact';
import message, { SnapShot, MessageTypes, Message } from '@/modules/contact/message';
import { FirestoreDate } from '@/modules/firestore';

interface DisplayMessage {
  date: FirestoreDate;
  messages: Message[];
}

interface DataType {
  exhibitorCID: string | null;
  exhibitorUID: string | null;
  buyerCID: string | null;
  buyerUID: string | null;
  contactID: string | null;
  brandID: string | null;
  avatarExhibitor: string | null;
  avatarBuyer: string | null;
  buyer: PublicBuyer | null;
  contact: Contact | null;
  exhibitor: PublicExhibitor | null;
  companyBuyer: PublicBuyerCompany | null;
  companyExhibitor: PublicExhibitorCompany | null;
  messages: Message[];
  loading: boolean;
  snapshot: any;
  displayMessages: null | DisplayMessage[];
}

export default Vue.extend({
  name: 'exhibitor-contact-chat',
  data(): DataType {
    return {
      exhibitorCID: '',
      exhibitorUID: '',
      buyerCID: '',
      buyerUID: '',
      brandID: '',
      contactID: '',
      avatarExhibitor: null,
      avatarBuyer: null,
      buyer: null,
      exhibitor: null,
      contact: null,
      companyBuyer: null,
      companyExhibitor: null,
      messages: [],
      loading: false,
      snapshot: new SnapShot(),
      displayMessages: null,
    };
  },
  computed: {
    messageTypes() {
      return MessageTypes;
    },
  },
  methods: {
    async setSnapshot() {
      if (!this.contactID) return;
      this.snapshot.snapshot(
        this.contactID,
        this.buyerCID,
        this.exhibitorCID,
        await this.snapShotCallback,
        (err: Error) => {
          this.$fatal(err);
        },
      );
    },
    async snapShotCallback(val: Message[]) {
      const isMessageDelete = this.messages.length > val.length;
      this.messages = val;
      this.groupMessagesByDate(this.messages);
      await this.updateContact();
      if (isMessageDelete) return;
      this.scrollToBottom();
    },
    groupMessagesByDate(messages: Message[]) {
      // MEMO 送信日毎にmessagesをまとめる。
      const groupedMessages = messages.reduce<any[]>((result, val, i) => {
        if (i === 0) {
          const initialVal = {
            date: val.data.registeredDate,
            messages: [val],
          };
          return [...result, initialVal];
        }
        const lastMessage = messages[i - 1];
        const currentMessageDate = calender.formatDateJP2(val.data.registeredDate);
        const lastMessageDate = calender.formatDateJP2(lastMessage.data.registeredDate);
        if (currentMessageDate === lastMessageDate) {
          result[result.length - 1].messages.push(val);
          return [...result];
        }
        const newVal = {
          date: val.data.registeredDate,
          messages: [val],
        };
        return [...result, newVal];
      }, []);
      this.displayMessages = groupedMessages;
    },
    async setIds() {
      if (!(this.contact && this.contact.data)) return;
      this.exhibitorCID = this.contact.data.exhibitor;
      this.buyerCID = this.contact.data.buyer;
      this.brandID = this.contact.data.brandId;
      try {
        this.loading = true;
        if (!this.buyerCID || !this.exhibitorCID || !this.brandID) return;

        const resCompanyBuyer = await publicBuyerCompany.load(this.buyerCID);
        if (!resCompanyBuyer) return;
        this.companyBuyer = resCompanyBuyer;
        this.buyerUID = resCompanyBuyer.data.owner;

        const resBrand = await publicBrand.load(this.brandID);
        if (!resBrand) return;
        this.exhibitorUID = resBrand.data.base.staff;

        // const resCompanyExhibitor = await companyExhibitor.load(
        //   this.exhibitorCID,
        // );
        const resCompanyExhibitor = await publicExhibitorCompany.load(
          this.exhibitorCID,
        );
        if (!resCompanyExhibitor) return;
        this.companyExhibitor = resCompanyExhibitor;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchBuyer() {
      if (!this.buyerUID) return;
      try {
        this.loading = true;
        const res = await publicBuyer.load(this.buyerUID);
        this.buyer = res;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchExhibitor() {
      if (!this.exhibitorUID) return;
      try {
        this.loading = true;
        const res = await publicExhibitor.load(this.exhibitorUID);
        this.exhibitor = res;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchContact() {
      this.contactID = this.$route.params.id;
      try {
        this.loading = true;
        const res = await contact.load(this.contactID);
        this.contact = res;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAvatarExhibitor() {
      // if (!this.exhibitorCID) return;
      if (
        !this.exhibitor || !this.exhibitor.data
      ) throw Error('exhibitor is null');

      try {
        this.avatarExhibitor = await genDownloadImageUrlByImage(
          sizes.x512,
          this.exhibitor.data.profileImage,
        );
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    async fetchAvatarBuyer() {
      // if (!this.buyerCID) return;
      if (
        !this.buyer || !this.buyer.data
      ) throw Error('this.buyer is null');

      try {
        this.avatarBuyer = await genDownloadImageUrlByImage(
          sizes.x512,
          this.buyer.data.profileImage,
        );
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    onClickListButton() {
      this.$router.push({ name: 'exhibitor-contact-list' });
    },
    async onMessageSend(val: {
      text: string;
      withVideoUrl: boolean;
      docs: any[];
    }) {
      if (
        !this.exhibitorCID
        || !this.buyerCID
        || !this.exhibitorUID
        || !this.contactID
        || !this.contact
      ) return;
      const newMessage = message.createNewMessage(
        this.exhibitorCID,
        this.buyerCID,
      );
      newMessage.data.text = val.text;
      newMessage.data.withVideoUrl = val.withVideoUrl;
      newMessage.data.docs = val.docs;
      newMessage.data.type = MessageTypes.exhibitor;
      try {
        this.$loading(true);
        const res = await message.save(
          this.exhibitorUID,
          this.contactID,
          this.exhibitorCID,
          newMessage,
        );
        if (!res) return;
        this.contact.data.asReads = [];
        this.contact.data.latestSendDt = firebase.now();
        await this.updateContact();
        this.scrollToBottom();
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.$loading(false);
      }
    },
    async onDeleteMessage(target: Message) {
      if (!this.exhibitorCID || !this.exhibitorUID || !this.contactID) return;
      target.data.deleter = this.exhibitorUID;
      target.data.isActivate = false;
      try {
        const res = await message.save(
          this.exhibitorUID,
          this.contactID,
          this.exhibitorCID,
          target,
        );
        if (!res) return;
        this.messages = this.messages.map((val: Message) => {
          if (val.id === target.id) return res;
          return val;
        });
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    setAsReadDateTime() {
      if (!this.contact) return;
      const { asReadDateTimes = [] } = this.contact.data;
      const uid = this.$auth.uid;
      const isInAsReadDateTimes = asReadDateTimes.find(
        (val) => val.uid === uid,
      );
      const dt = Date.now();
      let newAsReadDateTimes;
      if (!isInAsReadDateTimes) {
        const newAsReadDateTime = { uid, dt };
        newAsReadDateTimes = [...asReadDateTimes, newAsReadDateTime];
      } else {
        newAsReadDateTimes = asReadDateTimes.map((val) => {
          if (val.uid === uid) return { uid, dt };
          return val;
        });
      }
      this.contact.data.asReadDateTimes = newAsReadDateTimes;
    },
    setAsRead() {
      if (!this.contact) return;
      const { asReads = [] } = this.contact.data;
      const uid = this.$auth.uid;
      const isInAsReads = asReads.includes(uid);
      if (!isInAsReads) asReads.push(uid);
      this.contact.data.asReads = asReads;
    },
    async updateContact() {
      if (!this.contact) return;
      this.setAsRead();
      this.setAsReadDateTime();
      const uid = this.$auth.uid;
      try {
        const res = await contact.save(uid, this.contact);
        if (!res) return;
        this.contact = res;
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messageArea: any = this.$refs.messages;
        const messageAreaHeight = messageArea.scrollHeight;
        messageArea.scrollTop = messageAreaHeight;
      });
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    try {
      this.$loading(true);
      await this.fetchContact();
      if (!this.contact) return;
      await this.setIds();
      await this.fetchBuyer();
      await this.fetchExhibitor();
      await this.fetchAvatarExhibitor();
      await this.fetchAvatarBuyer();
      await this.setSnapshot();
    } finally {
      this.$loading(false);
    }
  },
  async mounted() {
    try {
      this.$loading(true);
      await this.fetchContact();
      if (!this.contact) return;
      await this.setIds();
      await this.fetchBuyer();
      await this.fetchExhibitor();
      await this.fetchAvatarExhibitor();
      await this.fetchAvatarBuyer();
      await this.setSnapshot();
    } finally {
      this.$loading(false);
    }
  },
  destroyed() {
    this.snapshot.detach();
  },
});
